import React from 'react';

interface EncerramentoFormProps {
	values?: any
	onSubmit: (event: any) => void
}

const EncerramentoForm = React.forwardRef((props: EncerramentoFormProps, ref: React.Ref<any>) => {
	const submitForm = React.useCallback(() => {
		document.getElementById('encerramento_estagio_form_submit')?.click();
	}, []);

	const resetForm = React.useCallback(() => {
		document.getElementById('encerramento_estagio_form_reset')?.click();
	}, []);

	React.useImperativeHandle(ref, () => ({
		submit: submitForm,
		reset: resetForm,
	}), [resetForm, submitForm]);

	const onSubmit = React.useCallback((event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		event.stopPropagation();

		const form = event.target as HTMLFormElement;
		const formData = new FormData(form);
		const formValues = Object.fromEntries(formData);

		formValues.data = new Date().toISOString();

		if (formValues?.relatorio_recebido_em && typeof formValues?.relatorio_recebido_em === 'string') {
			const date = new Date(`${formValues.relatorio_recebido_em}T00:00:00-0300`).setHours(12, 0, 0, 0);
			formValues.relatorio_recebido_em = (new Date(date).toISOString());
		}

		props.onSubmit(formValues);
	}, [props]);

	return (
		<form id="encerramento_estagio_form" onSubmit={onSubmit}>
			<div className='row'>
				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='relatorio_recebido_em'>Data da entrega</label>
						<input
							id="relatorio_recebido_em"
							name="relatorio_recebido_em"
							type='date'
							className='form-control'
							required
						/>
					</div>
				</div>

				<div className='col-md-6'>
					<div className='form-group'>
						<label htmlFor='nota_do_relatorio'>Nota atribuída</label>

						<input
							id='nota_do_relatorio'
							name='nota_do_relatorio'
							type='number'
							min={0}
							max={10}
							step={0.01}
							required
							className='form-control'
						/>

					</div>
				</div>
			</div>

			<input id="encerramento_estagio_form_reset" type='reset' style={{ display: 'none' }} />
			<input id="encerramento_estagio_form_submit" type='submit' style={{ display: 'none' }} />
		</form>
	);
});

EncerramentoForm.displayName = 'EncerramentoForm';

export default EncerramentoForm;
